import products from './modules/products/src/index';
import suppliers from './modules/suppliers/src/index';

export default [products, suppliers];
